export const TypeofCompany = [
    {id: 0, name: "Proprietor"},
    {id: 1, name: "LLP"},
    {id: 2, name: "Private Limited"},
    {id: 3, name: "Others"},
]